const resource = {
    resource_identifier_in_use: 'The API identifier {{indicator}} is already in use',
    cannot_delete_management_api: 'Cannot delete Cast Identity Management API.',
    cannot_modify_management_api: 'Cannot modify Cast Identity Management API.',
};
export default Object.freeze(resource);
